import { Empty, EmptyProps } from 'antd';

const EmptyData = (props: EmptyProps): JSX.Element => (
	<Empty {...props} image={Empty.PRESENTED_IMAGE_SIMPLE}>
		{props.children}
	</Empty>
);

export default EmptyData;
